import React from 'react'
import { mutualTheme } from '~/utils/theme'
import { ChevronDownIcon } from '~/assets/icons'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core'

type AccordionActionsProps = {
  title: string
}

export const AccordionActions: React.FC<AccordionActionsProps> = ({ title, children }) => {
  return (
    <Accordion
      sx={{
        backgroundColor: 'common.white',
        boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.08)',
        borderRadius: 1
      }}
    >
      <AccordionSummary
        aria-controls='panel1a-content'
        id='panel1a-header'
        expandIcon={<ChevronDownIcon htmlColor={mutualTheme.palette.textGray2.main} />}
      >
        <Typography variant='airbnbH4' color='textGray2.main'>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          {children}
        </Typography>
      </AccordionDetails>
    </Accordion>
  )
}
